import { render, staticRenderFns } from "./adminLogin.vue?vue&type=template&id=4526d7f0"
import script from "./adminLogin.vue?vue&type=script&lang=js"
export * from "./adminLogin.vue?vue&type=script&lang=js"
import style0 from "./adminLogin.vue?vue&type=style&index=0&id=4526d7f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports